import Constants from "../main/Constants";
import CustomKendoWindow from "./CustomKendoWindow";
import DockManager from "./DockManager";
import VideoWindow from "./VideoWindow";

export default class ProctorKendoWindow extends CustomKendoWindow {

	constructor(context, testerIdentifier, testerName) {
		super(context, testerIdentifier, testerName);
		this.createKendoWindow();
		this.addKeyboardShortcuts();
		this.lockStatus = false;
	}

	getKeyboardCommands() {
		return [
			//when adding new commands, make sure all of the keys are in lower case
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "k"], run : this.lowerHand.bind(this)},
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "c"], run : this.switchToChat.bind(this)},
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "u"], run : this.startCall.bind(this)},
			{keys : [Constants.Keys.CONTROL, "m"], run : this.muteAudio.bind(this)},
			{keys : [Constants.Keys.CONTROL, Constants.Keys.SHIFT, "v"], run : this.muteVideo.bind(this)},
			{keys : [Constants.Keys.ALT, Constants.Keys.SHIFT, "c"], run : this.switchToChatWithTextFocus.bind(this)}
		];
	}

	createKendoWindow() {
		let that = this;
		let windowDiv = this.windowDiv;
		let context = this.context;
		let testerIdentifier = this.testerIdentifier;
		this.lockStatus = context.testerLockStatuses.get(testerIdentifier);
		this.isChatEnabled = true;
		this.kendoWindow = windowDiv.kendoWindow({
			width: `${ProctorKendoWindow.getWidth()}px`,
			height: `${ProctorKendoWindow.getHeight()}px`,
			minWidth: `${ProctorKendoWindow.getWidth()}px`,
			minHeight: `${ProctorKendoWindow.getHeight()}px`,
			actions: ["Hand", "Chat", "Minimize", "Close"],
			autoFocus: false,
			visible : false,
			title: that.testerName,
			open: function(e) {
				context.dockManager.centerWithOffset(this);
			},
			activate: function(e) {
				this.wrapper.trigger('focus');
			},
			close: function(e) {
				context.closeChatWindow(testerIdentifier);
				context.dockManager.unDockWindow(testerIdentifier);
			},
			minimize: function(e) {
				//If we are minimizing because of re-ordering the window, no need to dock it.  That will be done later.
				if(e.sender.wrapper.data('dockPosition')) {
					return;
				}
				context.dockManager.dockWindow(testerIdentifier);
				context.dockManager.reprocessDockedWindows();
				$k(e.sender.element[0].parentElement).find('button[aria-label="window-restore"]').kendoTooltip({content: rtp_i18next.t("generalWords:maximize")});
			},
			restore: function (e) {
				if(e.sender.wrapper.is(':hidden')) {
					e.sender.wrapper.show();
				}
				DockManager.resizeAndupdateWindowPosition(e.sender);
				context.dockManager.expandWindow(testerIdentifier);
			},
			dragend: function (e) {
				//dragging a window will undock it if it's not dragged into a dock position
				let dockPosition = e.sender.wrapper.data('dockPosition');
				if(!dockPosition) {
					context.dockManager.unDockWindow(testerIdentifier);
					CustomKendoWindow.clamp(that.kendoWindow);
				} else {
					e.sender.minimize();
					e.sender.wrapper.data('dockPosition', null);
					context.dockManager.reorderDockPositions(testerIdentifier, dockPosition);
				}
			}
		}).data('kendoWindow');
		this.kendoWindow.wrapper.data('identifier', testerIdentifier);
		this.handButton = this.kendoWindow.wrapper.find('button[aria-label="Hand"]');
		this.handButton.removeClass('k-button-flat');
		this.handButton.find('span').addClass('fa-solid fa-hand');

		if(this.lockStatus) {
			const newAction = {
				name: "unlock",
				text: "unlock"
			};
			this.kendoWindow.options.actions.push(newAction);
			this.unlockButton = $('<button id="overflowUnlockButton" ' +
				'class="k-window-titlebar-action k-button k-button-md k-rounded-md k-button-flat-base k-icon-button fa-lock" ' +
				'aria-label="unlock"' +
				'data-role="tooltip"' +
				'style="color: #fff; background-color: #ee6d7c !important; cursor: pointer; margin: 5px;" > ' +
				'<i class="icon-lock fa-solid fa-lock k-svg-icon k-button-icon">' +
				'</i></button>');
			this.kendoWindow.wrapper.find('.k-window-titlebar-actions').prepend(this.unlockButton);

			// Unlock Confirmation Dialog
			const testerUnlockBoxId = `unlockConfirmationDialog-${testerIdentifier}`;
			this.kendoWindow.wrapper.prepend($(`<div class="unlockConfirmationDialogContent" id="${testerUnlockBoxId}"></div>`));

			// Use .find() on the Kendo window wrapper instead of $k to ensure the dialog is scoped to this window instance.
			this.unlockConfirmationDialog = this.kendoWindow.wrapper.find(`#${testerUnlockBoxId}`);
			if (this.unlockConfirmationDialog.length > 0) {
				this.unlockConfirmationDialog.kendoDialog({
					width: "250px",
					appendTo: this.kendoWindow.wrapper,
					modal: true,
					title: "Confirm Unlock!",
					content: `Are you sure you want to unlock student <strong> ${this.context.getTesterFirstName(testerIdentifier)} ${this.context.getTesterLastName(testerIdentifier)} </strong>`,
					closable: true,
					visible: false,
					messages: {
						close: "Cancel"
					},
					actions: [
						{
							text: "Cancel",
							primary: false,
							cssClass: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base "
						},
						{
							text: "Unlock",
							primary: true,
							cssClass: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button-solid-primary",
							action: function (e) {
								that.context.unlockTester(testerIdentifier);
								that.hideUnlockButton();
								return true; // Prevent dialog from closing
							}
						}
					],
					open: function (e) {
						const parentWindow = that.kendoWindow.wrapper;
						const dialogWrapper = e.sender.wrapper;
						const parentRect = parentWindow[0].getBoundingClientRect();
						const dialogHeight = ProctorKendoWindow?.getHeight();

						let left = parentRect.left + Constants.DIALOG_OFFSET.DIALOG_LEFT_OFFSET;
						let top = parentRect.top + ( dialogHeight / 2 ) - Constants.DIALOG_OFFSET.DIALOG_TOP_OFFSET;

						//if top is not inside of the viewport, then set it to same top as parent window
						if(top < 0 || top > window.innerHeight) {
							top = parentRect.top;
						}

						//if left is not inside of the viewport, then set it to same left as parent window
						if(left < 0 || left > window.innerWidth) {
							left = parentRect.left;
						}

						// Have to use setTimeout for positioning since Kendo doesn't apply the styles right away
						setTimeout(function () {
							dialogWrapper.css({
								position: 'fixed',
								top: top,
								left: left
							});
						}, 0);

						if (!e?.sender?.dialogWrapper?.is('.unlockConfirmationBoxTitleBar')) {
							e?.sender?.dialogWrapper?.find('.k-dialog-titlebar').addClass("unlockConfirmationBoxTitleBar");
						}
					}
				});
			} else {
				console.error('Unlock confirmation dialog element not found');
			}
		}

		// New Chat Received
		this.chatButton = this.kendoWindow.wrapper.find('button[aria-label="Chat"]');
		this.chatButton.find('span').addClass('fa-solid fa-comment');
		this.chatButton.hide();
		this.chatButton.append($('<span>').addClass('unseenChatCount chat-notification').text(this.unseenChatCount));
		this.errorHandler();
		this.attachProctorListeners();
		this.addTooltips();
		this.preventDblClickAndRightClick();

		//Create one video window per kendo window
		this.videoWindow = new VideoWindow(context, testerIdentifier);
		this.kendoWindow.open();
	}

	lowerHand() {
		if (this.isIconHandRaised) {
			this.context.lowerHand(this.testerIdentifier);
		}
	}

	startCall() {
		if($('#videoBtn-' + this.testerIdentifier).prop("disabled")) {
			return;
		}
		this.videoBtnClickHandler();
	}

	hideUnlockButton() {
		this.unlockButton?.css("display", 'none');
	}

	muteAudio() {
		if(this.isVideoCallRunning()) {
			this.videoWindow.muteAudioBtnClickHandler();
		}
	}

	muteVideo() {
		if (this.isVideoCallRunning()) {
			this.videoWindow.muteVideoBtnClickHandler();
		}
	}

	switchToChatWithTextFocus() {
		if(this.isVideoCallRunning) {
			this.switchToChat();
		}
		this.kendoChat.wrapper.find('.k-input-inner').focus();
	}

	addTooltips(){
		this.kendoWindow.wrapper.find('button[aria-label="Close"]').kendoTooltip({position: "right" , content: rtp_i18next.t("generalWords:close")});
		super.addTooltips.call(this, true);
	}

	errorHandler() {
		//Kendo seems to have a bug with custom icons, which causes console errors.  This catches the error so that no console errors will be shown.
		let _actionForIcon = this.kendoWindow._actionForIcon;
		this.kendoWindow._actionForIcon = function(e) {
			try {
				return _actionForIcon(e);
			} catch(e) {
				console.log(e);
			}
		};
	}

	attachProctorListeners() {
		this.handButton.off('click', this.lowerHandClickHandler.bind(this)).on('click', this.lowerHandClickHandler.bind(this));
		this.unlockButton?.off('click', this.unlockClickHandler.bind(this)).on('click', this.unlockClickHandler.bind(this));
		this.kendoWindow.wrapper.off('focus', this.windowFocusHandler.bind(this)).on('focus', this.windowFocusHandler.bind(this));
		this.kendoWindow.wrapper.off('chat-received', this.unseenChatButtonHandler.bind(this)).on('chat-received', this.unseenChatButtonHandler.bind(this));
		this.kendoWindow.wrapper.off('clear-unseen-chats', this.clearUnseenChatsHandler.bind(this)).on('clear-unseen-chats', this.clearUnseenChatsHandler.bind(this));
		this.kendoWindow.wrapper.find('input.k-input-inner').off('focus', this.chatFocusHandler.bind(this)).on('focus', this.chatFocusHandler.bind(this));
		this.chatButton.off('click', this.unseenChatBtnClickHandler.bind(this)).on('click', this.unseenChatBtnClickHandler.bind(this));
		this.chatButton.kendoTooltip({position: "top" , content: rtp_i18next.t("generalWords:newMessages")});

		let that = this;
		this.kendoWindow.dragging._draggable.bind("drag", function(e) {
			that.context.dockManager.dragWindow(e, that.context);
		});
		this.windowDiv.off('enableEndChatBtn',this.enableEndChatBtn.bind(this)).on('enableEndChatBtn',this.enableEndChatBtn.bind(this));
		this.windowDiv.off('disableEndChatBtn',this.disableEndChatBtn.bind(this)).on('disableEndChatBtn',this.disableEndChatBtn.bind(this));
	}

	lowerHandClickHandler() {
		this.context.lowerHand(this.testerIdentifier);
	}

	unlockClickHandler() {
		this.unlockConfirmationDialog.data("kendoDialog").open();
	}

	windowFocusHandler() {
		if(this.context.dockManager.isWindowOverflowed(this.testerIdentifier)) {
			return;
		}
		this.clearUnseenChats();
	}

	unseenChatButtonHandler() {
		let context = this.context;
		let testerIdentifier = this.testerIdentifier;
		let isMinimized = this.kendoWindow.options.isMinimized;
		if (!isMinimized) {
			return;
		}
		this.unseenChatCount++;
		this.kendoWindow.wrapper.addClass('highlightChatWindow');
		if (context.dockManager.isWindowOverflowed(testerIdentifier)) {
			context.dockManager.overflowWindows.get(testerIdentifier).trigger('chat-received');
			return;
		}
		this.chatButton.find('.unseenChatCount').text(this.unseenChatCount);
		this.chatButton.show();
	}

	clearUnseenChatsHandler() {
		let context = this.context;
		let testerIdentifier = this.testerIdentifier;
		if(context.dockManager.isWindowOverflowed(testerIdentifier)) {
			context.dockManager.overflowWindows.get(testerIdentifier).trigger('clear-unseen-chats');
		}
		this.chatButton.hide();
		this.kendoWindow.wrapper.removeClass('highlightChatWindow');
		this.unseenChatCount = 0;
		context.sendUnseenReceivedChatMessage(testerIdentifier);
	}

	postMessage(message) {
		let that = this;
		let textMessage = {'text' : message.data.text, 'timestamp' : new Date(message.data.jsonTimestamp), 'msgId': message.data.msgId, 'historical': message.data.isHistorical};
		if (typeof message.data.text === 'object') {
			textMessage = message.data.text;
		}
		if (message.data.isHistorical && message.data.clientId === this.context.clientId) {
			this.kendoChat.postMessage(textMessage);
			return;
		}
		if (message.data.clientId !== this.context.clientId) {
			this.kendoChat.renderMessage({
				type: "text",
				text: textMessage.text,
				msgId: textMessage.msgId,
				timestamp : new Date(message.data.jsonTimestamp)
			}, {
				id: message.data.clientId,
				name: message.data.senderType === Constants.Role.TESTER ? that.context.getTesterDisplayName(message.data.testerIdentifier) : rtp_i18next.t("proctorWidget:proctor")
			});
			this.kendoWindow.wrapper.trigger('chat-received');
		}
	}

	clearUnseenChats() {
		if (this.kendoWindow.options.isMinimized) {
			return;
		}
		this.kendoWindow.wrapper.trigger('clear-unseen-chats');	
	}

	//the text box doesn't trigger the window's focus event, so we need to make its focus also clear the chats
	chatFocusHandler() {
		this.clearUnseenChats();
	}

	unseenChatBtnClickHandler() {
		this.kendoWindow.restore();
	}

	static getWidth() {
		return 265;
	}

	static getHeight() {
		return 400;
	}

	enableEndChatBtn(e){
		this.isChatEnabled = true;
		this.endBtn.prop("disabled", false);
	}

	disableEndChatBtn(e){
		this.isChatEnabled = false;
		//If we are on the video screen, we don't want to disable the button.
		if(this.endBtn.hasClass('endCallBtn')) {
			return;
		}
		this.endBtn.prop("disabled", true);
	}

	disableVideoBtn() {
		$('#videoBtn-' + this.testerIdentifier).prop("disabled", true);
	}

	enableVideoBtn() {
		$('#videoBtn-' + this.testerIdentifier).prop("disabled", false);
	}

	setHandIconLowered() {
		this.handButton.removeClass('rtp-active-toolsTabBtn');
		this.isIconHandRaised = false;
		this.handTooltip.refresh();
	}

	setHandIconRaised() {
		this.handButton.addClass('rtp-active-toolsTabBtn');
		this.isIconHandRaised = true;
		this.handTooltip.refresh();
	}

	changeVideoLabelToInCall(testerIdentifier){
		CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier), rtp_i18next.t("videoMonitoring:inVideoCall"),true);
	}

	changeVideoLabelToVideo(testerIdentifier){
		CustomKendoWindow.changeVideoLabel($('#videoLabel-'+this.testerIdentifier), rtp_i18next.t("generalWords:startCall"),false);
	}

	cleanupController(){
		this.kendoWindow.destroy();
	}
}
